/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Novel_Ape_DropInputs */

const fr_stock_novel_ape_drop = /** @type {(inputs: Stock_Novel_Ape_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon Programme Personnel`)
};

/**

* @param {Stock_Novel_Ape_DropInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stock_novel_ape_drop = /** @type {((inputs?: Stock_Novel_Ape_DropInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Novel_Ape_DropInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stock_novel_ape_drop(inputs)
});